import React from 'react'
import { IoPlayCircleOutline } from 'react-icons/io5'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { NavLink } from 'react-router-dom'

const InstaVideoCard = ({url, imageUrl, title}) => {
  return (
    <div className='w-[150px] md:w-[240px] hover:scale-110 transition duration-300 ease-in rounded-lg border-2 shadow-lg'>
    
        <NavLink to={`${url}`} target='_blank' >
        <div className='relative bg-bgDark bg-opacity-80 rounded-lg overflow-hidden  pointer-events-auto'>
            <LazyLoadImage className='h-[150px] md:h-[240px]' src={imageUrl} loading='lazy' alt='img'></LazyLoadImage>
            <div className='absolute text-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
                   <IoPlayCircleOutline size={100} />
              </div>
            </div>
            <p className='text-blue-700 font-bold text-md md:text-xl leading-6 text-center mt-6 text-wrap w-full mb-4'>{title}</p>
        </NavLink>
        
    </div>
  )
}

export default InstaVideoCard